import React from 'react';
import { AlertCircle, Clock, Battery, Brain } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-12 px-4 bg-white" data-id="element-146">
      <div className="max-w-3xl mx-auto" data-id="element-147">
        <div className="space-y-6 text-gray-700" data-id="element-148">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 text-center mb-8" data-id="element-149">
            Si eres psicóloga, esto te resultará muy familiar…
          </h2>

          <div className="bg-gray-50 p-6 rounded-2xl border border-gray-100 shadow-sm" data-id="element-150">
            <p className="mb-4" data-id="element-151">
              Terminas el día agotada… Sabes que debes preparar sesiones… Abres
              la computadora… Y comienzas otra vez desde cero.
            </p>
            <p className="mb-4" data-id="element-152">
              Buscando ejercicios. Buscando actividades. Buscando materiales.
              Buscando cómo adaptar cada intervención a cada paciente.
            </p>
            <p className="italic font-medium text-purple-700 border-l-4 border-purple-500 pl-4 py-2 bg-purple-50 rounded-r-lg" data-id="element-153">
              "Y el tiempo pasa. Y el cansancio aumenta. Y la mente no se
              detiene."
            </p>
          </div>

          <p className="font-medium" data-id="element-154">
            No porque no sepas trabajar. No porque no seas una buena
            profesional.
          </p>

          <div className="flex items-start gap-3 p-4 bg-red-50 rounded-xl border border-red-100 text-red-800" data-id="element-155">
            <AlertCircle className="w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-156" />
            <p className="font-bold" data-id="element-157">
              👉 Sino porque estás intentando sostener tu práctica sin un
              sistema que te sostenga a ti.
            </p>
          </div>

          <div className="mt-12" data-id="element-158">
            <h3 className="text-xl font-bold text-gray-900 mb-6 text-center" data-id="element-159">
              El problema real
            </h3>

            <div className="grid md:grid-cols-2 gap-8" data-id="element-160">
              <div data-id="element-161">
                <h4 className="font-bold text-purple-700 mb-4 flex items-center gap-2" data-id="element-162">
                  <Clock className="w-5 h-5" data-id="element-163" />
                  Hoy la práctica clínica exige:
                </h4>
                <ul className="space-y-2 text-sm md:text-base" data-id="element-164">
                  {['Preparar sesiones constantemente', 'Crear y adaptar material', 'Pensar cada intervención', 'Dar seguimiento a cada caso', 'Mantener continuidad terapéutica', 'Organizar procesos clínicos completos'].map((item, i) => <li key={i} className="flex items-center gap-2" data-id="element-165">
                      <div className="w-1.5 h-1.5 rounded-full bg-gray-400" data-id="element-166" />
                      {item}
                    </li>)}
                </ul>
              </div>

              <div data-id="element-167">
                <h4 className="font-bold text-red-600 mb-4 flex items-center gap-2" data-id="element-168">
                  <Battery className="w-5 h-5" data-id="element-169" />
                  El resultado:
                </h4>
                <ul className="space-y-2 text-sm md:text-base" data-id="element-170">
                  {['Improvisas más de lo que te gustaría', 'Llevas trabajo a casa', 'Sientes que nunca terminas', 'Te agotas antes de la mitad del año', 'Tu consulta podría estar mucho más organizada'].map((item, i) => <li key={i} className="flex items-center gap-2" data-id="element-171">
                      <div className="w-1.5 h-1.5 rounded-full bg-red-400" data-id="element-172" />
                      {item}
                    </li>)}
                </ul>
              </div>
            </div>

            <p className="text-center font-bold text-lg mt-8 text-gray-900" data-id="element-173">
              No es tu culpa. Nadie te entregó un sistema listo para usar.
            </p>
          </div>
        </div>
      </div>
    </section>;
}